import { withStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { hexToRGB } from '../../../../utils/hexToRGB';
import ChatIcon from "../../Common/Icons/ChatIcon";
import withErrorCatcher from '../../Common/withErrorCatcher';
import MesagePoint from './MesagePoint';


// Apply some reset
const styles = theme => {
    const whiteOpacity016 = hexToRGB('#FFFFFF', 0.16)

    return ({
        chatPoint: {
            bottom: 30,
            left: 20
        },

        chatButton: {
            margin: 0,
            paddingRight: 0,
            paddingLeft: 0,
            marginRight: 20,
            "&:hover": {
                backgroundColor: 'inherit',
            },
        },

        chatIconContainer: {
            height: 28,
            borderRadius: 16,
            "&:hover": {
                backgroundColor: whiteOpacity016,
            },
        }
    })
}


class ChatToolbar extends PureComponent {

    onChatClick = () => {
        const { dispatch, pathname } = this.props;
        if (pathname.includes('chat') && !pathname.includes('group/chat')) return
        dispatch({ type: 'TOGGLE_CHATS_MODAL' })
    }

    render() {
        const { classes, t } = this.props;

        return (
            <Tooltip title={t('Chat')} placement="bottom">
                <IconButton data-intrcm-id="ChatToolbar_ip44mnto" classes={{ label: classes.chatIconContainer, root: classes.chatButton }} aria-label="Chat" onClick={this.onChatClick}>
                    <MesagePoint classes={{ point: classes.chatPoint }} />
                    <ChatIcon />
                </IconButton>
            </Tooltip>

        )
    }
}

const mapStateToProps = (state) => ({
    lastEnterChat: state.userData.profileData.lastEnterChat,
    pathname: state.wrapper.pathname,
    profileData: state.userData.profileData
})

export default compose(withStyles(styles),
    withErrorCatcher(),
    withTranslation('feedToolbar'),
    connect(mapStateToProps))(ChatToolbar);